import { render } from "./ViewModeSwitcher.vue?vue&type=template&id=7fa78f44"
import script from "./ViewModeSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewModeSwitcher.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/ViewModeSwitcher.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7fa78f44"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7fa78f44', __exports__)) {
    api.reload('7fa78f44', __exports__)
  }
  
  module.hot.accept("./ViewModeSwitcher.vue?vue&type=template&id=7fa78f44", () => {
    api.rerender('7fa78f44', render)
  })

}


export default __exports__